import React, {useMemo} from "react";
import {useTranslation} from "@unibuddy/intl";
import {CardBodySection, CardBodySectionWrapper} from "@unibuddy/buddycard-ui";
import capitalize from "lodash/capitalize";

import {MentorDegreeField} from "../../../../../types/generated";
import {IntlNamespaces} from "../../../../../translations/types";
import {useUniversity} from "../../../UniversityProvider/UniversityProvider";

type DegreesProps = {
    degrees: MentorDegreeField[];
};

type OrderedDegreeType = {
    degreeType: string;
    degree: string[];
};

export const Degrees = ({degrees = []}: DegreesProps) => {
    const {t} = useTranslation(IntlNamespaces.MENTOR_CARD);
    const {degreeTypeOrder} = useUniversity();

    const orderedDegrees: OrderedDegreeType[] = useMemo(() => {
        const degreeMap = {};

        degrees.forEach((obj) => {
            if (obj.degree && obj.degreeType) {
                if (degreeMap[obj.degreeType]) degreeMap[obj.degreeType].push(obj.degree.name);
                else degreeMap[obj.degreeType] = [obj.degree.name];
            }
        });

        const orderedDeg: OrderedDegreeType[] = [];
        degreeTypeOrder.forEach((degree) => {
            if (degreeMap[degree.type])
                orderedDeg.push({
                    degreeType: degree.type,
                    degree: degreeMap[degree.type],
                });
        });

        return orderedDeg;
    }, [degreeTypeOrder, degrees]);

    return (
        <CardBodySectionWrapper space="medium">
            {orderedDegrees.map((degree) => {
                return (
                    <CardBodySection
                        key={degree.degreeType}
                        heading={t(
                            degree.degreeType.toLowerCase(),
                            `${capitalize(degree.degreeType)}(s)`,
                        )}
                        content={degree.degree.join(", ")}
                    />
                );
            })}
        </CardBodySectionWrapper>
    );
};
